import { styled } from '@frontend/theme';
import { AlertTitle as MUIAlertTitle } from '@mui/material';

export const AlertTitleSt = styled(MUIAlertTitle)(({ theme }) => ({
  color: theme.palette.primary[900],
  margin: 0,
}));
